// import { useEffect, useState } from 'react';

import '../stylesheets/Landing.css'
import '../stylesheets/Contact.css'

const Landing = () => {
    // const [projects, setProjects] = useState([{color: "purple"}]);
    // const [idx, setIdx] = useState(0);
    const email = "devansrinivasan13@gmail.com"

    // useEffect(() => {
        // setProjects([
        //     {
        //         title: "Automated Research",
        //         initials: "Ar",
        //         link: "",
        //         repo_link: "",
        //         description: "Enterprise-level automated research system, that given a use case described with natural language, deploys an deploys parallelized asynchronous ai agents as a research team, to find structured data addressing the research use case. Unfortunately this is a private project thus the application and code is not available.",
        //         experience: "",
        //         tech: ['LLMs', 'RAG', 'AI Webscraping', 'ScrapegraphAI', 'Perplexity', 'Selenium'],
        //         featured: true,
        //         color: "purple",
        //     },
        // ]);

        // setIdx(0);
    // }, [])

    return <>
        <section id='landing'>
            <div className="wrapper">
                <div className="landing-content">
                    <div className='left-content'>
                        <h1 className="primary-text">Devan Srinivasan </h1>
                        <p className='landing-body primary-text'>
                            Hi! I'm Devan, an incoming PhD student at the University of Toronto part of the computational linguistics lab, supervised by Dr. Gerald Penn. My research interests revolve around mechanistic interpretability and mathematics, and I am also interested in semantics and knowledge representation. I am also an incoming machine learning engineer at Pinterest, where I work on image quality and visual understanding. Work aside, I generally love building and solving meaningful problems. In my free time I like playing sports like Badminton, Soccer, and Boxing, and am learning Chess.
                        </p>

                        <h2 className='landing-body'>
                            <span className="alt-text purple">CONNECT WITH ME</span>
                        </h2>
                        <div className="contact-wrapper">
                            <a href="https://www.linkedin.com/in/devan-srinivasan-ba0058156/"><img src="/images/linkedin_purple_128.png" alt="linkedin logo"/></a>
                            <a href="https://github.com/devan-srinivasan"><img src="/images/github_logo.png" alt="github logo"/></a>
                            <a href={"mailto:" + email}><img src="/images/email_purple_128.png" alt="email logo"/></a>
                            <button onClick={(event) => { event.preventDefault(); window.open("/files/Resume.pdf"); }}>
                                <img src="/images/resume_purple_128.png" alt="resume logo"/>
                            </button>
                        </div>
                    </div>
                    <img id='profile' src="./images/funko_devan.png" alt='profile'></img>
                </div>
                
            </div>
        </section>
    </>;
}

export default Landing;